import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/port/authentication.service';
import { UserStore } from '@app/core/store/user.store';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.smart.component.html',
  styleUrl: './sidebar.smart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarSmartComponent {
  private readonly authService = inject(AuthenticationService);
  private readonly userStore = inject(UserStore);
  private readonly router = inject(Router);

  /**
   * Déconnexion complète
   */
  logout(): void {
    console.log('🚪 SIDEBAR: Déconnexion demandée');
    
    // Cast vers l'orchestrateur pour accéder à logout()
    const orchestrator = this.authService as any;
    if (orchestrator.logout) {
      orchestrator.logout();
      console.log('✅ SIDEBAR: Déconnexion effectuée');
    }
    
    // Nettoyer le store utilisateur
    this.userStore.clear();
    
    // Rediriger vers la page de login
    this.router.navigate(['/login']);
    console.log('➡️ SIDEBAR: Redirection vers login');
  }
}
